import Modal from '@/components/Modal/';
import { noop } from '@/utils/util';
import loadingImg from '@/assets/images/tiny.gif';
import Ajax from '@/utils/ajax';
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import classNames from 'classnames';
import i18n from 'react-intl-universal';
import styles from './EditorModal.scss';
import Button from '../../components/Button/Button';

@withRouter
export default class EditorVideoModal extends Component {
  static defaultProps = {
    onModalCancelClick: noop,
    onModalConfirmBtnClick: noop,
  };
  static VALID_VIDEO_URL = /^https?:\/\/(?:[\w.]*?\.(?:youku|tudou|qq)\.com|[\w.-]*?\.acgvideo\.com)\//i;

  constructor(props) {
    super(props);
    this.state = {
      error: '',
      fetchingVideo: false,
    };
  }

  // 获取视频信息
  getVideoInfo = (url) => {
    const { match } = this.props;
    const { params: { noteId } } = match;
    const { onModalConfirmBtnClick } = this.props;
    if (!this.isVideoURLAvailable(url)) {
      this.setState({
        error: i18n.get('modal.wrong-video-source'),
      });
      return;
    }
    this.setState({
      fetchingVideo: true,
    });
    Ajax.getVideoInfo({
      video_url: url,
      note_id: noteId,
    }).then((res) => {
      const { data } = res;
      this.setState({
        error: '',
        fetchingVideo: false,
      });
      const videoInfo = {
        id: data.id,
        url: data.player_url,
        provider: data.provider,
        flash: data.swf_player_url,
        cover_id: data.cover_img_uuid,
        description: data.title || data.title || '',
      };
      onModalConfirmBtnClick('videoModal', { videoInfo });
    }).catch((error) => {
      this.setState({
        error: i18n.get('modal.fetch-video-info-failed'),
        fetchingVideo: false,
      });
    });
  }

  isVideoURLAvailable = (url) => {
    return EditorVideoModal.VALID_VIDEO_URL.test(url);
  }

  onConfirmBtnClick = () => {
    const url = (this.urlInput.value || '').trim();
    if (!url) {
      const error = i18n.get('error.link-no-empty');
      this.setState({
        error,
      });
    } else {
      this.getVideoInfo(url);
    }
  }

  render() {
    const { error, fetchingVideo } = this.state;
    const { onModalCancelClick, visible } = this.props;
    const inputWrapClass = classNames(styles['input-prepend'], {
      [styles['video-loading']]: fetchingVideo,
    });
    return (
      <Modal
        width={412}
        visible
        showFooter={false}
        showMask
        closable
        isMiddle
        onCancel={onModalCancelClick}
      >
        <div className={classNames(styles['kalamu-modal'], styles['kalamu-video-modal'])}>
          <h3>{i18n.get('modal.insertvideo')}</h3>
          <div className={styles['video-des']}>
            <span>
              {i18n.get('modal.only-support')}
              <a
                href="http://www.youku.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                {i18n.get('modal.yk')}/
              </a>
              <a
                href="http://v.qq.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                {i18n.get('modal.tc')}
                {i18n.get('modal.video')}
              </a>
            </span>
          </div>
          <div className={classNames(styles['modal-body'])}>
            <div className={inputWrapClass}>
              <span className={styles['add-on']}><i className="fa fa-link"/></span>
              <input
                autoFocus
                name="url"
                placeholder={i18n.get('modal.video-url-des')}
                type="text"
                ref={(v) => {
                  this.urlInput = v;
                }}
              />
            </div>
            {
              fetchingVideo &&
              <div className={styles['message-text']}>
                <img src={loadingImg} alt="加载"/>
                {i18n.get('modal.video-loading')}
              </div>
            }
            {
              !fetchingVideo &&
              <div className={styles['message-text']}>{error}</div>
            }
            <div className={styles['btn-wrap']}>
              <Button
                type={'primary'}
                className={styles['btn']}
                onClick={this.onConfirmBtnClick}
              >
                {i18n.get('modal.confirm')}
              </Button>
              <Button className={styles['btn']} onClick={onModalCancelClick}>{i18n.get('modal.cancel')}</Button>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/EditorModal/EditorVideoModal.js